/*
   ****** The below React component is developed by Your Company Name ******
   Please don't remove, replace, or edit this header information
   Component: <Footer.js>
   Description: This React component represents the footer of the application. It provides information about the technology powering the application. 
   The footer includes a link to Aplus-technology's website. The styling is done using MUI components.
   Dependencies: React, MUI components.
 */

   import React from 'react';
   import { styled } from '@mui/system';
   
   const FooterStyled = styled('footer')({
       backgroundColor: '#000410',
       color: 'white',
       textAlign: 'center',
       borderTop: '2px solid dodgerblue',
       padding: '20px 0',
       position: 'fixed',
       bottom: 0,
       left: 0,
       width: '100%',
       display: 'flex',
       flexDirection: 'column',
       alignItems: 'center',
   });
   
   const FooterText = styled('p')({
       marginBottom: '0px',
       fontFamily: 'Sans-serif',
       fontSize: 15,
   });
   
   const AppName = styled('span')({
       fontWeight: 'bold',
       fontSize: 14,
       color: '#39B3D7',
       padding: '2px 6px',
       borderRadius: '3px',
       backgroundColor: '#1a1a1a',
   });
   
   const Footer = () => {
       return (
           <FooterStyled>
               {/*
                  <FooterText>
                      Powered by{' '}
                      <a
                          href="https://aplus-technology.com/"
                          target="_blank"
                          rel="noreferrer"
                          style={{ color: 'dodgerblue' }}
                      >
                          Aplus-technology
                      </a>
                  </FooterText>
                  */}
   
               <AppName>Vaculink 2.0r</AppName>
           </FooterStyled>
       );
   };
   
   export default Footer;
   